import React from 'react';
import styles from './Mango.module.css';
import { useState, useEffect } from 'react';

const Mango = () => {

  const [isDirty] = useState(false);

  useEffect(() => {

    const onLocationChange = (e) => {
      if (isDirty) {
        document.dispatchEvent(new CustomEvent('modalx', { href: '/mango' }));
      } else {
        document.dispatchEvent(new CustomEvent('navconfirmed', {detail: e}));
      }
    }

    document.addEventListener('popstateb', onLocationChange);

    return () => {
      document.removeEventListener('popstateb', onLocationChange);
    }
    
  }, [isDirty]);

  return (
    <div className={styles.Mango}>
      <div className='contentComponents'>
        Mango Component
      </div>
    </div>
  )

}

Mango.propTypes = {};

Mango.defaultProps = {};

export default Mango;
